import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchLoanDetails,
  fetchLoanDetailsSuccess,
  fetchLoanDetailsFailure,
} from "../slices/loanDetailsSlice";

function* fetchLoanDetailsSaga(action) {
  try {
    const { slug } = action.payload;

    const response = yield call(
      fetch,
      `${process.env.REACT_APP_API_URL}/v1/loans/view/${slug}`,
    );

    const data = yield response.json();
    const fetchedData = data.data;

    yield put(fetchLoanDetailsSuccess(fetchedData));
  } catch (error) {
    yield put(fetchLoanDetailsFailure("Error fetching loan data"));
  }
}

export function* watchLoanDetails() {
  yield takeLatest(fetchLoanDetails.type, fetchLoanDetailsSaga);
}
